export default __webpack_public_path__ + "static/media/25102402.72696768.png";